import colors from '../../styles/theme/foundation/colors';

const menuButtonStyles = {
  background: colors.greyScale['100'],
  color: colors.greyScale['900'],
  textStyle: 'bodyMd',
  fontWeight: '400',
  position: 'inherit',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '10px 14px',
  height: '40px',
  _focus: {
    outline: `1px solid ${colors.primaryScale['200']}`,
    boxShadow: 'none'
  },
  _disabled: { opacity: 0.5 },
  _hover: {
    bg: 'greyScale.100',
    color: 'greyScale.500'
  }
};

const menuBodyStyles = {
  padding: '10px',
  overflowY: 'auto',
  maxH: '300px',
  color: colors.greyScale['600']
};

const hoverStyle = {
  bgColor: 'rgba(0, 142, 255, 0.1)',
  cursor: 'pointer',
  color: colors.primaryScale['600']
};

const menuMultipleStyles = {
  maxHeight: '180px',
  overflowY: 'auto',
  width: '100%',
  margin: 0,
  borderTop: 0,
  background: 'white',
  position: 'absolute',
  zIndex: 1000,
  listStyle: 'none',
  padding: 0
};

const selectedItemStyles = {
  marginLeft: '5px',
  backgroundColor: 'aliceblue',
  borderRadius: '10px'
};

const selectedItemIconStyles = { cursor: 'pointer' };

const comboBoxStyles = { width: '100%' };

const icons = {
  BsThreeDots:
  'M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z'
};

export { comboBoxStyles,
  hoverStyle,
  icons,
  menuBodyStyles,
  menuButtonStyles,
  menuMultipleStyles,
  selectedItemIconStyles,
  selectedItemStyles };
